/* eslint-disable */
export default {
  currentCall: 'Appel en cours',
  viewCalls: 'Afficher les appels',
  view: 'Afficher',
  incomingCall: '{numberOf} appel entrant',
  incomingCalls: '{numberOf} appels entrants',
  callOnHold: '{numberOf} appel en attente',
  callsOnHold: '{numberOf} appels en attente',
  otherDeviceCall: '{numberOf} appel sur d’autres appareils',
  otherDeviceCalls: '{numberOf} appels sur d’autres appareils',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
